import React from 'react';
import PoolProperties from './PoolProperties';
import {getSeasonsUsageData} from 'api/quickCalcs';
import Output from './Output';
import {Footer, FooterButton} from 'components/layout';
import events from 'lib/events';
import {injectIntl, intlShape} from 'react-intl';

class SeasonsUsage extends React.Component {
  static propTypes = {
    intl: intlShape,
  };

  static stages = {
    input: 0,
    report: 1,
  };

  state = {
    stage: SeasonsUsage.stages.input,
    data: {},
  };

  submit = pool => {
    return getSeasonsUsageData(pool)
      .then(x => {
        this.setState({
          stage: SeasonsUsage.stages.report,
          data: x,
        });
      });
  };

  print = () => {
    events.publish('print', <Output intl={this.props.intl} data={this.state.data} />);
  };

  render() {
    const {intl} = this.props;
    const {formatMessage} = intl;
    const {stage, data} = this.state;

    return <div className='qc-seasons-usage'>
      {stage === SeasonsUsage.stages.input ?
        <PoolProperties onSubmit={this.submit} /> :
        null}

      {stage === SeasonsUsage.stages.report ?
        <Output intl={intl} data={data} /> :
        null}

      {stage === SeasonsUsage.stages.report ?
        <Footer>
          <FooterButton icon={'fa-2x bl bl-print'} label={formatMessage({id: 'general.print'})} onClick={this.print} />
        </Footer> :
        null}
    </div>;
  }
}

export default injectIntl(SeasonsUsage);
